export default __webpack_public_path__ + "static/media/benefit-2-cf.b1e94e6e.svg";